// sendMessageToCustomerService.js
'use strict';
import { push as customerServicePush } from '../resource/customerService.js';
import { getIsOnMobile } from '../resource/getUserAgent.js';

/**
 * Hand a message draft over to the customer service messenger instead of chat.
 * Only text is sent; media is dropped (zE API has no attachment support).
 * @param {object} param
 * @param {string} param.text - draft text; when empty the messenger just opens.
 * @return {Promise} Resolves once the messenger is asked to open.
 * @example
 * await sendMessageToCustomerService({ text: 'I need help' });
 */
const sendMessageToCustomerService = async ({ text }) => {
  // Keyboard is up when a text field is focused on mobile; wait for it to dismiss
  const { visualViewport } = window;
  const activeElement = document.activeElement;
  if (
    visualViewport &&
    getIsOnMobile() &&
    (['INPUT', 'TEXTAREA'].includes(activeElement?.tagName) ||
      activeElement?.isContentEditable)
  ) {
    // Not every input blurs itself after submit, so dismiss the keyboard here
    activeElement.blur();
    await new Promise(resolve => {
      visualViewport.addEventListener('resize', resolve, { once: true });
      // 1s fallback; the resize typically lands in 90-200ms on devices.
      setTimeout(resolve, 1000);
    });
  }
  customerServicePush({
    args: text ? ['showNewMessage', text] : ['open'],
  });
};

export default sendMessageToCustomerService;
